function getUnifySelectInventoryActivityCommodityList(commodity) {
  const commodityList = [];
  (Array.isArray(commodity) ? commodity : [commodity]).forEach((commodity2, i) => {
    if (commodity2.items && commodity2.items.length) {
      commodityList.push(...commodity2.items.map((item, j) => {
        const result = Object.assign({
          cxNo: `${i}_${j}`,
          packageId: commodity2.commodityId,
          lineNo: `${i}`
        }, item);
        commodity2.classificationId === "8" && (result.packageSize = commodity2.quantity.toString());
        return result;
      }));
    } else {
      commodityList.push(Object.assign({ cxNo: `${i}`, lineNo: `${i}` }, commodity2));
    }
  });
  return commodityList;
}
export { getUnifySelectInventoryActivityCommodityList };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/business/unifySelectInventory/activity/getCommodityList.js